import { render, staticRenderFns } from "./phone-number-column.vue?vue&type=template&id=36c02785"
import script from "./phone-number-column.vue?vue&type=script&lang=js"
export * from "./phone-number-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36c02785')) {
      api.createRecord('36c02785', component.options)
    } else {
      api.reload('36c02785', component.options)
    }
    module.hot.accept("./phone-number-column.vue?vue&type=template&id=36c02785", function () {
      api.rerender('36c02785', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/contact/phone-number-column.vue"
export default component.exports